import { GuiDetailBenutzerAnfallstelle } from "./GuiDetailBenutzerAnfallstelle";

export class GuiDetailMandantEanv extends GuiDetailBenutzerAnfallstelle {
}
